import { Command as CommandPrimitive } from 'cmdk'
import TokenImg from '@/src/components/ui/token-img'
import { cn } from '@/src/utils/styles'
import { PriceDisplay } from '../price-display'
import { PriceChange } from '../ui/price-change'
import { type SearchResult, tokenId } from './types'

interface ItemProps {
  item: SearchResult
  prefix: string
  onSelect: (item: SearchResult) => void
  onHover?: (item: SearchResult) => void
  className?: string
}

export const Item = ({
  item,
  prefix,
  onSelect,
  onHover,
  className,
}: ItemProps) => (
  <CommandPrimitive.Item
    className={cn(
      'relative flex cursor-pointer select-none items-center justify-between px-4 py-2 m-1 outline-none',
      'data-[disabled=true]:pointer-events-none data-[disabled=true]:opacity-50',
      '[&[data-selected="true"]]:bg-surface1 [&[data-selected="true"]]:rounded-2xl',
      '[&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0',
      className,
    )}
    value={`${prefix}-${tokenId(item)}`}
    onMouseDown={() => onSelect(item)}
    onSelect={() => onSelect(item)}
    onMouseEnter={() => onHover?.(item)}
  >
    <div className='flex items-center gap-3 max-h-15'>
      <TokenImg
        src={item.icon}
        ticker={item.symbol}
        width={40}
        height={40}
        unoptimized
      />
      <div>
        <div className='text-primary text-base font-semibold truncate max-w-[180px]'>
          {item.name}
        </div>
        <div className='text-sm text-secondary font-normal'>{item.symbol}</div>
      </div>
    </div>
    <div className='flex flex-col items-end'>
      <div className='text-primary text-base font-normal'>
        <PriceDisplay zeroValue='' price={item.price ?? 0} />
      </div>
      <PriceChange change={item.change ?? 0} />
    </div>
  </CommandPrimitive.Item>
)
